export default {
    benefits: []
}